import { API_URL } from "../global";
import { AuthDataState, RootState, loginCredential, AuthData } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { AUTH_TOKEN, IS_LOGGED_IN } from "./getters.names";
import { LOGIN, GET_PROFILE_DATA, LOGOUT } from "./actions.names";
import axios from "axios";
import {
  SET_AUTH_DATA,
  RETRIEVE_SESSION_DATA,
  TOGGLE_LOGIN,
  CLEAR_AUTH_DATA
} from "./mutations.names";
import Vue from "vue";

const AUTH_API_URL: string = `${API_URL}/rest-auth/login/`;
const LOGOUT_API_URL: string = `${API_URL}/rest-auth/logout/`;

const namespaced: boolean = false;

export const state: AuthDataState = {
  authData: undefined,
  error: false
};

const getters: GetterTree<AuthDataState, RootState> = {
  [AUTH_TOKEN](state: AuthDataState): string | null {
    return state.authData ? state.authData.key : null;
  },
  [IS_LOGGED_IN](state: AuthDataState): boolean {
    return state.authData ? true : false;
  }
};

const actions: ActionTree<AuthDataState, RootState> = {
  [LOGIN]({ commit, dispatch }: any, payload: loginCredential): any {
    return new Promise((resolve, reject) => {
    payload.grant_type = "password";
    axios.post(AUTH_API_URL, payload).then(async ({ data }: any) => {
      const expire_date = new Date();
      expire_date.setSeconds(
        expire_date.getSeconds() + (data.expires_in - 300)
      );
      data.expire_date = expire_date;
      commit(SET_AUTH_DATA, data);
      await dispatch(GET_PROFILE_DATA);
      resolve();
    });
  });
  },
  [LOGOUT]({commit, state}) {
    return new Promise((resolve, reject) => {
      if (state.authData!.key){
        axios.post(LOGOUT_API_URL, {}, {headers: {
          Authorization: `Token ${state.authData!.key}`
        }}).then((data: any) => {
          commit(CLEAR_AUTH_DATA);
          resolve();
        });
      }
    });
  }
};

const mutations: MutationTree<AuthDataState> = {
  [SET_AUTH_DATA](state, payload: AuthData) {
    state.error = false;
    state.authData = payload;
    window.localStorage.setItem("cotoken", payload.key);
    //window.localStorage.setItem("tokenexp", payload.expire_date.toISOString());
  },
  [CLEAR_AUTH_DATA](state){
    state.error = false;
    state.authData = undefined;
    window.localStorage.removeItem("cotoken");
  },
  [RETRIEVE_SESSION_DATA](state) {
    const token = window.localStorage.getItem("cotoken");
    if (token) {
      const data = {
        key: token,
        // expire_date: new Date(window.localStorage.getItem("tokenexp") as string)
      };
      Vue.set(state, "authData", data);
    }
  }
};

export const AuthenticationData: Module<AuthDataState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
